module.exports = __webpack_public_path__ + "img/eye.c08fa450.svg";